export function hasAuthCookie() {
  // We delete any remaining cookie when logging with keycloak.
  // Having a cookie means our last log in was using cookie mechanism and it is thereof fine to use it
  return document.cookie.includes('auth=');
}
